import { HexColorPicker } from "@circle-react-uikit/HexColorPicker";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { useIsWithinCompassInputPrefix } from "@/react/components/SettingsApp/CompassCompat/InputPrefixContext";

export interface ColorPickerPrefixProps {
  disabled: boolean;
  onChange: (value: string) => void;
  onClosePicker: () => void;
  onOpenPicker: () => void;
  shouldShow: boolean;
  value: string;
}

export const ColorPickerPrefix = ({
  value,
  disabled,
  shouldShow,
  onChange,
  onOpenPicker,
  onClosePicker,
}: ColorPickerPrefixProps) => {
  const isWithinCompassInputPrefix = useIsWithinCompassInputPrefix();

  return (
    <div
      className={classNames({
        "py-3 pl-4": !isWithinCompassInputPrefix,
        "cursor-not-allowed": disabled,
      })}
    >
      <HexColorPicker
        value={value}
        onChange={onChange}
        onOpenPicker={onOpenPicker}
        onClosePicker={onClosePicker}
        show={shouldShow}
        disabled={disabled}
      />
    </div>
  );
};
